import { createAsyncThunk } from '@reduxjs/toolkit';
import { partnerService } from '../../services';

const getPartners = createAsyncThunk(
    'partners/getPartners',
    async (payload, thunkAPI) => {
        try {
            const response = await partnerService.getPartners(
                payload.companyId
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const addOrRemoveSelectedPartner = createAsyncThunk(
    'partners/addOrRemoveSelectedPartner',
    async (payload, thunkAPI) => {
        try {
            const response =
                await partnerService.addOrRemoveSelectedPartner(
                    payload.companyId,
                    payload.partnerId,
                    payload.addRemove
                );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const getPartnerConnections = createAsyncThunk(
    'partners/getPartnerConnections',
    async (payload, thunkAPI) => {
        try {
            const response =
                await partnerService.getPartnerConnections(
                    payload.companyId
                );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const deletePartnerConnection = createAsyncThunk(
    'partners/deletePartnerConnection',
    async (payload, thunkAPI) => {
        try {
            const response =
                await partnerService.deletePartnerConnection(
                    payload.companyId,
                    payload.connectionId
                );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const createPartnerConnection = createAsyncThunk(
    'partners/createPartnerConnection',
    async (payload, thunkAPI) => {
        try {
            const response = await partnerService.createPartnerConnection(payload.companyId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response);
        }
    }
);

const updatePartnerConnection = createAsyncThunk(
    'partners/updatePartnerConnection',
    async (payload, thunkAPI) => {
        try {
            const response = await partnerService.updatePartnerConnection(payload.companyId, payload.partnerConnectionId, payload.data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response);
        }
    }
);

const resetAllConnectionselectedincspAs0 = createAsyncThunk(
    'partner/resetAllConnectionselectedincspAs0',
    async (payload, thunkApi) => {
        try{
            const response = await partnerService.resetAllConnectionselectedincspAs0(payload.companyId)
            return response.data;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message)
        }
    }
);

export {
    getPartners,
    addOrRemoveSelectedPartner,
    getPartnerConnections,
    deletePartnerConnection,
    createPartnerConnection,
    updatePartnerConnection,
    resetAllConnectionselectedincspAs0
};
